import { render } from "./Attachment.vue?vue&type=template&id=5639ac5a&scoped=true"
import script from "./Attachment.vue?vue&type=script&lang=js"
export * from "./Attachment.vue?vue&type=script&lang=js"

import "./Attachment.vue?vue&type=style&index=0&id=5639ac5a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5639ac5a"],['__file',"src/components/Attachment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5639ac5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5639ac5a', __exports__)) {
    api.reload('5639ac5a', __exports__)
  }
  
  module.hot.accept("./Attachment.vue?vue&type=template&id=5639ac5a&scoped=true", () => {
    api.rerender('5639ac5a', render)
  })

}


export default __exports__